import { render, staticRenderFns } from "./NewComicsList.vue?vue&type=template&id=a9b1ac3c&scoped=true&"
import script from "./NewComicsList.vue?vue&type=script&lang=js&"
export * from "./NewComicsList.vue?vue&type=script&lang=js&"
import style0 from "./NewComicsList.vue?vue&type=style&index=0&id=a9b1ac3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b1ac3c",
  null
  
)

export default component.exports